function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "className", "clickableAttribute", "dataTestId", "id", "onClose", "onOpen", "placement", "returnFocus", "target", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { createPopper } from '@popperjs/core';
import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import StyledTooltip, { StyledTooltipArrow, StyledTooltipChildrenContainer, StyledTooltipClose, StyledTooltipContent, StyledTooltipMask, StyledTooltipTitle } from "./styled";
import BackgroundProvider from "../BackgroundProvider";
import { useBrand } from "../BrandProvider";
import { Close } from "../Icon";
import Link from "../Link";
import Text from "../Text";
import { TOOLTIP_CLOSE, TOOLTIP_CONTENT, TOOLTIP_TARGET, TOOLTIP_TITLE } from "../../constants";
import { specificDataAndRest, uniqueId } from "../../utils";
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    className = _ref.className,
    clickableAttribute = _ref.clickableAttribute,
    dataTestId = _ref.dataTestId,
    customId = _ref.id,
    onClose = _ref.onClose,
    onOpen = _ref.onOpen,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$returnFocus = _ref.returnFocus,
    returnFocus = _ref$returnFocus === void 0 ? true : _ref$returnFocus,
    target = _ref.target,
    title = _ref.title,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var hasOpened = useRef(false);
  var id = useRef(customId || uniqueId('csl-tooltip'));
  var linkRef = React.useRef();
  var popper = useRef();
  var targetEl = useRef();
  var tooltipEl = useRef();
  var theme = useTheme();
  var _ref2 = useBrand() || {},
    _ref2$testAttributeNa = _ref2.testAttributeName,
    testAttributeName = _ref2$testAttributeNa === void 0 ? 'data-qa-id' : _ref2$testAttributeNa;
  var testAttributes;
  var getTestAttributes = function getTestAttributes(element) {
    var _testAttributes;
    return ((_testAttributes = testAttributes) === null || _testAttributes === void 0 ? void 0 : _testAttributes[element]) || {};
  };
  if (dataTestId) {
    testAttributes = {};
    testAttributes.link = _defineProperty({}, testAttributeName, "".concat(dataTestId, "-link"));
    testAttributes.overlay = _defineProperty({}, testAttributeName, "".concat(dataTestId, "-overlay"));
  }
  var close = function close() {
    if (popper.current) popper.current.destroy();
    setIsOpen(false);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return isOpen && e.keyCode === 27 && close();
  };
  var handleTargetClick = function handleTargetClick(e) {
    e.preventDefault();
    if (!targetEl.current) return;
    if (!tooltipEl.current) return;
    popper.current = createPopper(targetEl.current, tooltipEl.current, {
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, 16]
        }
      }],
      placement: placement
    });
    setIsOpen(true);
  };
  useEffect(function () {
    window.addEventListener('keydown', handleKeyDown);
    return function cleanup() {
      window.removeEventListener('keydown', handleKeyDown);
    };
  });
  useEffect(function () {
    var _popper$current;
    if (!tooltipEl.current) return;
    if (isOpen) hasOpened.current = true;
    if (hasOpened.current === true) {
      if (isOpen && onOpen) onOpen();
      if (!isOpen && onClose) onClose();
    }
    (_popper$current = popper.current) === null || _popper$current === void 0 ? void 0 : _popper$current.update();
    if (isOpen) {
      tooltipEl.current.focus({
        preventScroll: true
      });
    } else if (!isOpen && returnFocus && hasOpened.current === true) {
      var _linkRef$current;
      (_linkRef$current = linkRef.current) === null || _linkRef$current === void 0 ? void 0 : _linkRef$current.focus();
    }
  }, [isOpen]);
  var childrenContainerClassName = classnames('csl-tooltip__children-container', {
    'csl-tooltip__children-container--no-title': !title
  });
  var tooltipClassName = classnames('csl-tooltip__tooltip', {
    'csl-tooltip__tooltip--closed': !isOpen
  }, className);
  var _specificDataAndRest = specificDataAndRest(rest, clickableAttribute),
    _specificDataAndRest2 = _slicedToArray(_specificDataAndRest, 2),
    clickableAttributes = _specificDataAndRest2[0],
    rootProps = _specificDataAndRest2[1];
  return /*#__PURE__*/React.createElement("span", rootProps, /*#__PURE__*/React.createElement("span", {
    "aria-describedby": id.current,
    ref: function ref(_ref3) {
      if (_ref3 !== null) targetEl.current = _ref3;
    }
  }, /*#__PURE__*/React.createElement(Link, _extends({}, getTestAttributes('link'), {
    "data-csl-selector": TOOLTIP_TARGET,
    onClick: handleTargetClick,
    className: "csl-tooltip__link",
    role: "button",
    ref: linkRef
  }), target)), isOpen && /*#__PURE__*/React.createElement(StyledTooltipMask, {
    className: "csl-tooltip__mask",
    onClick: close
  }), /*#__PURE__*/React.createElement(StyledTooltip, _extends({
    $closed: !isOpen
  }, getTestAttributes('overlay'), {
    id: id.current,
    role: "tooltip",
    className: tooltipClassName,
    ref: function ref(_ref4) {
      tooltipEl.current = _ref4;
    },
    tabIndex: 0
  }), /*#__PURE__*/React.createElement(StyledTooltipContent, {
    className: "csl-tooltip__content",
    "data-csl-selector": TOOLTIP_CONTENT
  }, /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: {
      cssValue: theme.tooltip_overlay_color_background
    }
  }, /*#__PURE__*/React.createElement(StyledTooltipClose, _extends({
    "aria-label": "Close tooltip",
    className: "csl-tooltip__close",
    "data-csl-selector": TOOLTIP_CLOSE,
    onClick: close,
    type: "button"
  }, clickableAttributes), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Close, {
    size: "s3",
    iconSize: "md"
  }))), typeof title === 'string' ? /*#__PURE__*/React.createElement(StyledTooltipTitle, {
    className: "csl-tooltip__title"
  }, /*#__PURE__*/React.createElement(Text, {
    "data-csl-selector": TOOLTIP_TITLE,
    size: "s3",
    weight: "bold"
  }, title)) : title, /*#__PURE__*/React.createElement(StyledTooltipChildrenContainer, {
    $noTitle: !title,
    "aria-hidden": Boolean(!isOpen),
    className: childrenContainerClassName
  }, /*#__PURE__*/React.createElement(Text, null, children)))), /*#__PURE__*/React.createElement(StyledTooltipArrow, {
    className: "csl-tooltip__arrow",
    "data-popper-arrow": true
  })));
};
Tooltip.displayName = 'Tooltip';
export default Tooltip;